module.exports = __webpack_public_path__ + "assets/2-Phoenix-SDR-AE-jobs.27bc2e7e.png";